import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { countries } from "./countries";

export const validBrazilianDDDs: number[] = [
    // SP
    11, 12, 13, 14, 15, 16, 17, 18, 19,
    // RJ
    21, 22, 24,
    // ES
    27, 28,
    // MG
    31, 32, 33, 34, 35, 37, 38,
    // PR
    41, 42, 43, 44, 45, 46,
    // SC
    47, 48, 49,
    // RS
    51, 53, 54, 55,
    // DF, GO, TO
    61, 62, 63, 64,
    // MT, MS
    65, 66, 67,
    // AC, RO, AM, RR, PA, AP
    68, 69, 91, 92, 93, 94, 95, 96, 97,
    // BA, SE, AL, PE, PB, RN, CE, PI, MA
    71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 98, 99,
];

export const eightDigtisE164CountryCodes: number[] = [
    countries["Denmark"].code,
    countries["Norway"].code,
    countries["Singapore"].code,
];

export const sevenDigitsE164CountryCodes: number[] = [
    countries["Palau"].code,
    countries["Marshall Islands"].code,
    countries["Aruba"].code,
    countries["Micronesia, Federated States of Micronesia"].code,
    countries["Belize"].code,
    countries["Maldives"].code,
    countries["Solomon Islands"].code,
    countries["Gabon"].code,
    countries["Lebanon"].code,
    countries["Liberia"].code,
    countries["Suriname"].code,
    countries["British Indian Ocean Territory"].code,
    countries["Brunei Darussalam"].code,
    countries["Estonia"].code,
    countries["Guyana"].code,
    countries["Iceland"].code,
    countries["Mauritius"].code,
    countries["Nauru"].code,
    countries["Netherlands Antilles"].code,
    countries["Panama"].code,
    countries["Timor-Leste"].code,
];

export class PhoneUtils {
    static toE164Phone(input: string): string {
        if (!input) {
            return null;
        }
        let value = input.replace(/[^\d]/g, "");

        let isEightDigitsInternationalNumber: boolean = eightDigtisE164CountryCodes.includes(
            parseInt(value.slice(0, 2))
        );

        let isSevenDigitsInternationalNumber: boolean = sevenDigitsE164CountryCodes.includes(
            parseInt(value.slice(0, 3))
        );

        let parsedDDD = parseInt(value.slice(0, 2));

        let isBrazillianPhone =
            (value.length === 11 && value[2] === "9") ||
            (!isEightDigitsInternationalNumber &&
                !isSevenDigitsInternationalNumber &&
                value.length === 10 &&
                !isNaN(parsedDDD) &&
                validBrazilianDDDs.includes(parsedDDD));

        return isBrazillianPhone ? `+55${value}` : `+${value}`;
    }

    static isValidE164Phone(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const phoneNumber = control.value;

            if (!phoneNumber) {
                return null;
            }

            const e164PhonePattern: RegExp = /^\+\d{7,18}$/;

            if (!e164PhonePattern.test(phoneNumber)) {
                return { invalidPhoneNumber: true };
            }

            return null;
        };
    }
}
